import TableRow, { TableRowProps } from "@material-ui/core/TableRow";
import React from "react";
import { SortableElement } from "react-sortable-hoc";

import SortableHandle from "./SortableHandle";
interface PropsTwo {
  disableDrag?: boolean;
}

type prop = PropsTwo | TableRowProps;

const SortableTableRow = SortableElement<prop>(
  ({ children, disableDrag, ...props }) => (
    <TableRow {...props}>
      {disableDrag ? null : <SortableHandle />}
      {children}
    </TableRow>
  )
);

export default SortableTableRow;
